import { Logger } from '@shared/utils'

const log = Logger('Branch')

const ALLOWED_DATA_KEYS = [
  '$deeplink_path',
  'journey_token',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'cbo',
  'provider_type_id',
]

const sanitize = (data = {}) =>
  Object.fromEntries(Object.entries(data).filter(([key, value]) => ALLOWED_DATA_KEYS.includes(key) && value != null))

const isAvailable = () => Boolean(window.branch)

const setIdentity = (userId) => {
  if (!isAvailable() || !userId) return
  window.branch.setIdentity(String(userId), (error) => {
    if (error) log.warn('setIdentity failed', error)
  })
}

const logout = () => {
  if (!isAvailable()) return
  window.branch.logout((error) => {
    if (error) log.warn('logout failed', error)
  })
}

const createLink = ({ channel, feature, campaign, data }) => {
  return new Promise((resolve, reject) => {
    if (!isAvailable()) return reject(new Error('Branch SDK is not available'))

    window.branch.link({ channel, feature, campaign, data: sanitize(data) }, (error, link) => {
      if (error || !link) {
        log.warn('createLink failed', error)
        window.honeybadger?.notify(error || new Error('Branch createLink returned no link'), { name: 'BranchCreateLink' })
        return reject(error || new Error('Branch link creation failed'))
      }
      resolve(link)
    })
  })
}

const setBranchViewData = (data) => {
  if (!isAvailable()) return
  window.branch.setBranchViewData({ data: sanitize(data) })
}

export default { isAvailable, setIdentity, logout, createLink, setBranchViewData }
